const setPartsPrice = (parts, currency) => {
    return parts.map((part) => {
        part.price = part['price_' + currency.toLowerCase()]
        part.price_src = part['price_' + currency.toLowerCase() + '_src']

        return part
    })
}

export default setPartsPrice
